export default __webpack_public_path__ + "static/media/el20.2a15f6a8.svg";